import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

// Provider
//import { CanActivateAuthGuard } from '@shared/CanActivateAuthGuard';

// ADMIN DEPLOY: Use this routes
const routes: Routes = [
    // Auth
    {
        path: '',
        component: BlankComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
            },
            // {
            //     path: '',
            //     loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
            // }
        ]
    },
    // Main / Market
    // {
    //     path: '',
    //     component: FullComponent,
    //     children: [
    //         { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) }
    //     ],
    //     canActivate: [CanActivateAuthGuard]
    // },
    {
        path: '**',
        redirectTo: '404'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            scrollPositionRestoration: 'top'
        }),
        NgbModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }

